import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlane = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m6.177 7.258 8.226-4.591M5.929 7.214 2.39 3.457a.667.667 0 0 1 .485-1.124h10.962c.515 0 .836.559.576 1.003l-5.628 9.636a.667.667 0 0 1-1.218-.157L6.085 7.492a.7.7 0 0 0-.156-.278"
	})
});
export default SvgPlane;
